export default __webpack_public_path__ + "static/media/img.26434178.png";